import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchAuthMe } from "./redux/slices/auth";
import { trackPageView } from "./utils/analytics";

import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";

import ProtectedRoute from "./admin/ProtectedRoute";
import Activities from "./admin/app/pages/activities/Activities";
import CreateActivity from "./admin/app/pages/activities/CreateActivity";
import EditActivity from "./admin/app/pages/activities/EditActivity";
import Reviews from "./admin/app/pages/reviews/Reviews";
import Leads from "./admin/app/pages/leads/Leads";
import Services from "./admin/app/pages/services/Services";
import CreateService from "./admin/app/pages/services/CreateService";
import EditService from "./admin/app/pages/services/EditService";
import Login from "./admin/auth/Login";
import RequestFormSettings from "./admin/app/pages/settings/RequestFormSettings";

import MainPage from "./main";
import ActivityPage from "./sections/pages/activity-page/activity-page";
import AllActivities from "./sections/pages/all-activities/all-activities";
import ServicesPage from "./sections/pages/services/services-page";
import AboutPage from "./sections/pages/about/about-page";
import AllReviews from "./sections/pages/all-reviews/all-reviews";
import CreateReview from "./sections/create-review/create-review";
import ContactsPage from "./sections/pages/contacts/contacts-page";

// Переходы между страницами в SPA — сообщаем аналитике вручную.
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(window.location.href);
  }, [location.pathname]);

  return null;
};

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAuthMe());
  }, [dispatch]);

  return (
    <div className="bg-kj-dark text-kj-ink font-mont">
      <Router>
        <RouteTracker />
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/activities" element={<AllActivities />} />
          <Route path="/services" element={<ServicesPage />} />
          {/* «О нас» и «Контакты» — отдельные страницы, а не якоря на главной:
              на них можно дать ссылку в переписке, их индексирует поиск, и
              человек с рекламы попадает сразу в нужный раздел. */}
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/activity/:id" element={<ActivityPage />} />
          {/* Отзывы были сняты с сайта, пока их не было ни одного: пустой
              блок «станьте первым» на странице тура за 2600 $ работал против.
              Теперь отзывы есть — менеджер загружает скриншоты через админку,
              и блок вернулся на место. */}
          <Route path="/reviews" element={<AllReviews />} />
          <Route path="/write-review" element={<CreateReview />} />

          <Route path="/admin" element={<Navigate to="/admin/activities" replace />} />
          <Route path="/admin/auth" element={<Login />} />
          <Route
            path="/admin/activities"
            element={
              <ProtectedRoute>
                <Activities />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/reviews"
            element={
              <ProtectedRoute>
                <Reviews />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/request-form"
            element={
              <ProtectedRoute>
                <RequestFormSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/leads"
            element={
              <ProtectedRoute>
                <Leads />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/services"
            element={
              <ProtectedRoute>
                <Services />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/create-service"
            element={
              <ProtectedRoute>
                <CreateService />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/edit-service"
            element={
              <ProtectedRoute>
                <EditService />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/create-activity"
            element={
              <ProtectedRoute>
                <CreateActivity />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/edit-activity"
            element={
              <ProtectedRoute>
                <EditActivity />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
